import { useContext } from 'react';

import { ThemeContext } from '../../contexts/theme';
import { handB, handW } from '../../assets/index';
import { about } from '../../portfolio';
import resumePDF from '../../assets/Resume_ACSNEVES.pdf';
import './About.css';

/* ------------------------- component ------------------------- */
const About = () => {
  const [{ themeName }] = useContext(ThemeContext);

  const { name, resume } = about;

  /* ------------------------- render ------------------------- */
  return (
    <div className='about center'>
      {name && (
        <div>
          <h1 className='hello'>
            Hi, I&apos;m<span className='about-name'> {name}</span>
            <img alt='waving hand' src={themeName === 'dark' ? (handW) : (handB)} className='wave' />
          </h1>
        </div>
      )}
      <div className='about-contact center'>
        {resume && (
          <a alt='resume' href={resumePDF} target='_blank' rel='noopener noreferrer'>
            <span type='button' className='btn btn-round'>
              Resume
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

export default About;
